import { useEffect } from "react";
import { api } from "@/lib/api";

export const SessionHeartbeat = () => {
  useEffect(() => {
    const beat = () => {
      if (document.visibilityState === "visible") api.post("/track/heartbeat").catch(() => {});
    };
    beat();
    const t = setInterval(beat, 60000);
    return () => clearInterval(t);
  }, []);
  return null;
};
